document.addEventListener('DOMContentLoaded', () => {
	const tabletBreakpoint = 992
	const detailSections = document.querySelectorAll('.team-member .column.details > div')
	
	const calculateHeights = () => {
		detailSections.forEach(section => {
			const content = section.querySelector('.drawer-content')
			if (content) {
				content.style.setProperty('--content-height', 'auto')
				content.style.setProperty('--content-height', `${content.scrollHeight}px`)
			}
		})
	}

	detailSections.forEach(section => {
		const heading = section.querySelector('.heading')
		if (heading) {
			heading.addEventListener('click', () => {
				if (window.innerWidth < tabletBreakpoint) {
					detailSections.forEach(item => {
						item === section ? item.classList.toggle('open') : item.classList.remove('open')
					})
				}
			})
		}
	})

	calculateHeights()
	
	// Open first section by default on mobile/tablet
	if (window.innerWidth < tabletBreakpoint && detailSections.length > 0) {
		detailSections[0].classList.add('open')
	}
	
	window.addEventListener('resize', calculateHeights)
})
